module.exports = __webpack_public_path__ + "static/media/error_icon.b1c99b2c.jpg";